import {
  START_LOADING_SUPPLIER_SUGGESTIONS,
  SUPPLIER_SUGGESTIONS_LOAD_SUCCESS,
  SUPPLIER_SUGGESTIONS_LOAD_FAILED,

  START_EDITING_SUPPLIER_SUGGESTION,
  FINISH_EDITING_SUPPLIER_SUGGESTION,
  EDIT_SUPPLIER_SUGGESTION_FIELD,

  SUPPLIER_SUGGESTION_UPDATE_SUCCESS,
  SUPPLIER_SUGGESTION_CREATE_SUCCESS,
} from "../actions/types";

const initialState = {
  loadingSupplierSuggestions: false,
  supplierSuggestions: [],

  editingRow: null,
  editedFields: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    /* ================= load ================= */

    case START_LOADING_SUPPLIER_SUGGESTIONS:
      return {
        ...state,
        loadingSupplierSuggestions: true,
      };

    case SUPPLIER_SUGGESTIONS_LOAD_SUCCESS:
      return {
        ...state,
        loadingSupplierSuggestions: false,
        supplierSuggestions: [...payload],
      };

    case SUPPLIER_SUGGESTIONS_LOAD_FAILED:
      return {
        ...state,
        loadingSupplierSuggestions: false,
      };

    /* ================= editing ================= */

    case START_EDITING_SUPPLIER_SUGGESTION:
      return {
        ...state,
        editingRow: payload,
        editedFields: {},
      };

    case FINISH_EDITING_SUPPLIER_SUGGESTION:
      return {
        ...state,
        editingRow: null,
        editedFields: {},
      };

    case EDIT_SUPPLIER_SUGGESTION_FIELD:
      return {
        ...state,
        editedFields: {
          ...state.editedFields,
          ...payload,
        },
        editingRow: {
          ...state.editingRow,
          ...Object.fromEntries(
            Object.entries(payload).map(([key, val]) => {
              if (
                typeof state.editingRow[key] === "object" &&
                state.editingRow[key]
              ) {
                return [
                  key,
                  {
                    ...state.editingRow[key],
                    _id: val,
                  },
                ];
              }
              return [key, val];
            })
          ),
        },
      };

    /* ================= update ================= */

    case SUPPLIER_SUGGESTION_UPDATE_SUCCESS:
      return {
        ...state,
        supplierSuggestions: state.supplierSuggestions.map(v =>
          v._id === payload._id ? payload : v
        ),
        editedFields: {},
        editingRow:
          state.editingRow && state.editingRow._id === payload._id
            ? payload
            : state.editingRow,
      };

    /* ================= create ================= */

    case SUPPLIER_SUGGESTION_CREATE_SUCCESS:
      return {
        ...state,
        supplierSuggestions: state.supplierSuggestions.concat([payload]),
        editingRow: null,
        editedFields: {},
      };

    default:
      return state;
  }
};
